import { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const ISLANDS = [
  { id: 'saintKitts', label: 'St. Kitts' },
  { id: 'nevis', label: 'Nevis' },
];

// Mirrors iOS islandSelectionButton: 🇰🇳 flag + island name in a gray pill,
// opens a small picker sheet. Selection persists in localStorage and reloads
// (same behavior the web app already had).
export default function IslandPicker() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const [selected, setSelected] = useState(
    () => localStorage.getItem('chef_selected_island') || 'saintKitts'
  );
  const current = ISLANDS.find((i) => i.id === selected) || ISLANDS[0];

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const choose = (id) => {
    if (id !== selected) {
      localStorage.setItem('chef_selected_island', id);
      window.location.reload();
    } else {
      setOpen(false);
    }
  };

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-xl bg-[#F2F2F7]"
      >
        <span className="text-base leading-none">🇰🇳</span>
        <span className="text-xs font-medium text-gray-900">{current.label}</span>
        <ChevronDown size={12} className={`text-gray-500 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute top-full right-0 mt-1.5 bg-white rounded-xl shadow-xl border border-black/5 overflow-hidden z-50 min-w-[140px]">
          {ISLANDS.map((island) => (
            <button
              key={island.id}
              onClick={() => choose(island.id)}
              className={`w-full flex items-center gap-2.5 px-4 py-2.5 text-sm ${
                selected === island.id ? 'text-[#FF3B30] font-semibold' : 'text-gray-800'
              } active:bg-gray-100`}
            >
              <span>🇰🇳</span>
              {island.label}
              {selected === island.id && (
                <span className="ml-auto w-1.5 h-1.5 rounded-full bg-[#FF3B30]" />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
